import { Component, Input, OnInit } from '@angular/core';
import { Account } from "../../../../interface/account.interface";
import { UserRatingApi } from "../../services/user-rating.api";
import { IonIcon, ModalController } from "@ionic/angular/standalone";
import { IonHeader, IonToolbar, IonTitle, IonButton, IonContent, IonList, IonItem } from "@ionic/angular/standalone";
import { Participant } from '../../../share/model/participant';
import { ParticipantRoles } from "../../../share/enum/participant-roles.enum";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SexyModule } from '@qid/sexy';
import { SuperButtonComponent, AvatarRoundComponent } from '@qid/super';

@Component({
  selector: 'add-user-rating',
  templateUrl: './add-user-rating.component.html',
  styleUrls: ['./add-user-rating.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    AvatarRoundComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton,
    IonContent,
    IonList,
    IonItem,
    IonIcon
  ],
})
export class AddUserRatingComponent implements OnInit {

  @Input() participants: Participant[] = []
  @Input() onRated: () => Promise<void>
  public rating = 0;
  public hoveredRating = 0;
  public stars = [1, 2, 3, 4, 5];
  public writingReviewForAccounts: Account[] = []
  public reviewText = ""

  public slides = {
    selectParticipants: 'selectParticipants',
    writeReview: 'writeReview',
    submitted: 'submitted'
  }

  public activeSlide: string = null;

  constructor(
    private userRatingApi: UserRatingApi,
    private modalController: ModalController
  ) {
  }

  ngOnInit() {

    this.hoveredRating = this.rating;

    const adminParticipant = this.participants.find(participant => participant.roles.indexOf(ParticipantRoles.admin) > -1)
    if (!adminParticipant) {
      return
    }
    this.writingReviewForAccounts.push(adminParticipant.account || adminParticipant.accountSnapshot)
    this.activeSlide = this.slides.writeReview

  }

  async ionViewDidEnter() {

  }

  rate(value: number) {
    this.rating = value;
  }

  hover(value: number) {
    this.hoveredRating = value || this.rating;
  }

  onReviewSubmit = async () => {

    if (this.rating < 1) {
      throw "Please select a rating for your review"
    }

    const res = await this.userRatingApi.create(
      {
        ratedToAccounts: this.writingReviewForAccounts,
        ratingDescription: this.reviewText,
        ratingNumber: this.rating,
        contextOfRating: "Hospitality"
      }
    )

    if (res && res.data) {
      // ponytail: refresh parent before close so view-share shows new averageRating
      if (this.onRated) {
        await this.onRated()
      }
      this.goToSlide(this.slides.submitted)
    }

  };

  goToSlide(slide) {
    this.activeSlide = slide
  }

  closeModal() {
    this.modalController.dismiss()
  }
}
